<script setup lang="ts">
const { toggle, isOpen } = useNavigation();
</script>

<template>
    <div
        class="fixed left-0 top-0 z-40 h-full w-nav-collapsed transition-transform duration-300 ease-out md:sticky md:h-screen md:transform-none print:hidden"
        :class="isOpen ? 'translate-x-0 transform-none 2xl:w-auto' : 'translate-x-[-100%] md:-translate-x-full'"
    >
        <slot />
        <span
            class="invisible fixed inset-0 -z-10 h-full w-full transform-none bg-gray-900 opacity-0 transition-opacity delay-75
            duration-300 ease-out 2xl:hidden"
            :class="{'!visible opacity-30 delay-300': isOpen}"
            @click="toggle"
        />
    </div>
</template>
